import { t } from '@lingui/macro';

// This is a how we can map error codes to error messages.
// As the list grows longer, we need to move this to a separate file.
export default function getErrorMessage(errorCode: any) {
    const key = Object.keys(errorCode).find(key => !!errorCode[key]) || '';
    const errorCodeUpperCase = errorCode[key]?.toUpperCase().replace('ERROR_CODE_', '');

    // Currently we only have translations that use 1 parameter.
    const validationErrorTextParams = errorCode.textParams ? Object.values(errorCode.textParams) : undefined;
    const firstParam =
        validationErrorTextParams && validationErrorTextParams.length > 0 ? validationErrorTextParams[0] : undefined;
    return errorCodeMessages(firstParam)[errorCodeUpperCase] ?? t`An error occured while saving the entry.`;
}

const errorCodeMessages = (param?: any) => {
    return {
        JOURNALVOUCHERNULL: t`The voucher is empty.`,
        JOURNALVOUCHERACCOUNTINGYEARDOESNOTEXIST: t`The date is within an accounting year which has not been created.`,
        JOURNALVOUCHERACCOUNTINGYEARCLOSED: t`Accounting year is closed.`,
        JOURNALVOUCHERDATAINTEGRITYERROR: null,
        JOURNALVOUCHERENTITYALREADYEXISTSERROR: t`Already existing entry.`,
        JOURNALVOUCHERNEXTNUMBERNOTWITHINBOUNDARIES: t`Voucher number is not within allowed values.`,
        JOURNALENTRYDATEACCOUNTINGYEARDOESNOTEXIST: t`Accounting year does not exist.`,
        JOURNALENTRYDATEACCOUNTINGYEARCLOSED: t`Accounting year is closed.`,
        JOURNALENTRYDATEACCOUNTINGYEARPERIODBARRED: t`The period has been barred.`,
        JOURNALENTRYDUEDATENOTSET: t`Due date is not set.`,
        JOURNALENTRYDUEDATENOTINRANGE: t`Due date is not set.`,
        JOURNALENTRYVOUCHERNUMBERNOTWITHINBOUNDARIES: t`Voucher number is not within allowed values.`,
        JOURNALENTRYACCOUNTNOTFOUND: t`The account does not exist.`,
        JOURNALENTRYACCOUNTNOTACCESSIBLE: t`The account does not have access.`,
        JOURNALENTRYWRONGACCOUNTTYPE: t`The account is not the right type`,
        JOURNALENTRYACCOUNTISBLOCKEDFORDIRECTENTRIES: t`This account does not allow direct entries.`,
        JOURNALENTRYCONTRAACCOUNTISBLOCKEDFORDIRECTENTRIES: t`This contra account does not allow direct entries.`,
        JOURNALENTRYWRONGCONTRAACCOUNTTYPE: t`The countra account is not the right type`,
        JOURNALENTRYEXCHANGERATEERROR: t`Exchange rate is not correct.`,
        JOURNALENTRYCONTRAACCOUNTNOTFOUND: t`The countra account does not exist.`,
        JOURNALENTRYCONTRAACCOUNTNOTACCESSIBLE: t`The countra account does not have access.`,
        JOURNALENTRYACCOUNTANDCONTRAACCOUNTNOTSET: t`Account and contra account are not set.`,
        JOURNALENTRYCURRENCYNOTFOUND: t`The currency does not exist.`,
        JOURNALENTRYCURRENCYNOTSET: t`The currency is not set.`,
        JOURNALENTRYSUPPLIERNOTFOUND: t`The supplier does not exist.`,
        JOURNALENTRYSUPPLIERNOTACCESSIBLE: t`The supplier is barred.`,
        JOURNALENTRYSUPPLIERNOTSET: t`The supplier is not set.`,
        JOURNALENTRYSUPPLIERANDACCOUNTNOTSET: t`Supplier and account are not set.`,
        JOURNALENTRYDISTRIBUTIONDIMENSIONACCESSNOTACCESSIBLE: t`Distribution dimension has no department access.`,
        JOURNALENTRYDEPARTMENTALDISTRIBUTIONNOTFOUND: t`The department does not exist.`,
        JOURNALENTRYDEPARTMENTALDISTRIBUTIONNOTACCESSIBLE: t`The department does not have access.`,
        JOURNALENTRYEMPLOYEENOTFOUND: t`The exployee does not exist.`,
        JOURNALENTRYEMPLOYEENOTACCESSIBLE: t`The employee does not have access.`,
        JOURNALENTRYEITHERAMOUNTSNOTSET: t`Amount is not set.`,
        JOURNALENTRYTYPENOTCORRECT: t`The entry type is not correct.`,
        JOURNALENTRYCUSTOMERANDACCOUNTNOTSET: t`The customer and account are not set.`,
        JOURNALENTRYCUSTOMERNOTFOUND: t`The customer does not exist.`,
        JOURNALENTRYCUSTOMERNOTACCESSIBLE: t`The customer does not have access.`,
        JOURNALENTRYPAYMENTDETAILSREQUIREDFIELDSWRONG: t`Payment details are wrong.`,
        JOURNALENTRYDIMENSIONUNIT1NOTFOUND: t`Unit 1 does not exist.`,
        JOURNALENTRYDIMENSIONUNIT2NOTFOUND: t`Unit 2 does not exist.`,
        JOURNALENTRYDIMENSIONORUNIT1NOTACCESSIBLE: t`Unit 1 is not accesible.`,
        JOURNALENTRYDIMENSIONORUNIT2NOTACCESSIBLE: t`Unit 2 is not accesible.`,
        JOURNALENTRYDIMENSIONQUANTITY1SETWITHOUTACCESS: t`No access for setting dimension quantity 1.`,
        JOURNALENTRYDIMENSIONQUANTITY2SETWITHOUTACCESS: t`No access for setting dimension quantity 2.`,
        JOURNALENTRYPROJECTIDSETWITHOUTMODULEACCESS: t`No access for setting project.`,
        JOURNALENTRYCOSTTYPESETWITHOUTMODULEACCESS: t`No access for setting cost type.`,
        JOURNALENTRYPROJECTNOTFOUND: t`Project does not exist.`,
        JOURNALENTRYPROJECTNOTACCESSIBLE: t`Project is not accesible.`,
        JOURNALENTRYCOSTTYPENOTFOUND: t`Cost type does not exist.`,
        JOURNALENTRYCOSTTYPENOTACCESSIBLE: t`Cost type is not accesible.`,
        JOURNALENTRYPROJECTCOSTTYPESETMISMATCH: t`There is no project for the cost type set.`,
        JOURNALENTRYPROJECTSETISCLOSED: t`The project set is closed.`,
        JOURNALENTRYPROJECTSETISMAINPROJECT: t`The project set is the main project.`,
        JOURNALENTRYPAYMENTDETAILSPAYMENTIDWRONGLENGTH: t`Payment ID in payment details does not have proper length.`,
        JOURNALENTRYPAYMENTDETAILSPAYMENTIDTOOSHORT: t`Payment message can have minimum ${param} characters`,
        JOURNALENTRYPAYMENTDETAILSPAYMENTIDTOOLONG: t`Payment message can have maximum ${param} characters`,
        JOURNALENTRYPAYMENTDETAILSPAYMENTIDDOESNOTMATCHSTRINGPATTERN: t`Payment ID in payment details is not correct.`,
        JOURNALENTRYPAYMENTDETAILSPAYMENTIDMUSTBENUMERIC: t`Payment ID in payment details must be a number.`,
        JOURNALENTRYACCRUALENDBEFORESTART: t`Accrual start date is greater than the end date.`,
        JOURNALENTRYACCRUALACCOUNTNOTFOUND: t`Accrual account does not exist.`,
        JOURNALENTRYASSETGROUPNOTFOUND: t`Asset group does not exist.`,
        JOURNALENTRYASSETNUMBERMUSTBEPOSITIVE: t`Asset number must be positive.`,
        JOURNALENTRYASSETSTARTNOTINACCOUNTINGYEAR: t`Asset start date is not within the accounting year.`,
        JOURNALENTRYASSETLIFETIMEMUSTBEPOSITIVE: t`Asset lifetime must be positive.`,
        JOURNALENTRYASSETWRONGENTRYTYPE: t`Wrong entry type for asset.`,
        JOURNALENTRYACCRUALWRONGENTRYTYPE: t`Wrong entry type for accrual.`,
        JOURNALENTRYASSETACCRUALERROR: t`Asset and accrual are not set.`,
        JOURNALENTRYPAYMENTDETAILSCREDITORIDDOESNOTMATCHSTRINGPATTERN: t`Supplier ID in payment details is not correct.`,
        JOURNALENTRYTEXTTOOLONG: t`The entry text must be less than 250 characters.`,
        JOURNALENTRYSUPPLIERINVOICETOOBIG: t`Invoice no. cannot be more than 30 digits`,
        CUSTOMER_INVOICE_IS_NOT_NUMERIC: t`Invoice no. must be a number.`,
        CUSTOMER_INVOICE_TOO_BIG: t`Invoice no. cannot be more than 9 digits`,
        LEDGER_MASSUPDATE_ILLEGALADDPERIOD: t`One or more entries is/are in a closed or non-existing period.`,
        LEDGER_MASSUPDATE_ERROR_ILLEGALDAYORMONTH: t`Invalid days and/or months`,
        ONLYONEITEMPERDIMENSION: t`Only one item per dimension is allowed.`,
        ONLYONEDISTRIBUTIONALLOWED: t`Only one distribution is allowed.`,
        CONTAINSINVALIDVALUES: t`Dimensions contain invalid values.`,
    };
};

export function getBookingErrorMessage(errorCode: any) {
    const key = Object.keys(errorCode).find(key => !!errorCode[key]) || '';

    switch (errorCode[key]?.toUpperCase()) {
        case 'ERROR_CODE_CUSTOMER_INVOICE_IS_NOT_NUMERIC':
            return t`Invoice no. must be a number.`;
        case 'ERROR_CODE_JOURNALENTRYCUSTOMERNOTFOUND':
            return t`The customer does not exist.`;
        case 'BOOKING_DAYBOOKS_ERROR_FROMDATE':
            return t`Invalid date in 'From date'.`;
        case 'BOOKING_DAYBOOKS_ERROR_TODATE':
            return t`Invalid date in 'To date'.`;
        default:
            return errorCode[key];
    }
}
